import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {LabAutomationAllSchemasQuery} from 'lab-automation/graphql/__generated/LabAutomationAllSchemasQuery';
import {LAB_AUTOMATION_ALL_SCHEMAS_QUERY} from 'lab-automation/graphql/AllSchemas';
import LookupConfigModal from 'lookup-config/LookupConfigModal';
import {RunLookupConfigModalProps} from 'lookup-config/LookupConfigUtils';
import {isLookupConfigValidForModal} from 'lookup-config/LookupStepInitializerUtils';
import notifications from 'notifications';
import runModal from 'ui-library/runModal';
import {withLoadingScreen} from 'util/Promises';

export default async function runLookupConfigModalForLabAutomation(
  modalProps: RunLookupConfigModalProps
): Promise<void> {
  const modalPropsWithEnvironment = {
    ...modalProps,
    allowReplicatesStep: modalProps.allowReplicatesStep ?? true,
    shouldShowIsMulti: modalProps.shouldShowIsMulti ?? true,
    shouldShowIsMultiFlatten: modalProps.shouldShowIsMultiFlatten ?? true,
    allowAlternatingGridPatterns: modalProps.allowAlternatingGridPatterns ?? true,
    shouldShowNullForEmptyContentsTooltip: true,
  };
  // Ensure all schemas are loaded
  await withLoadingScreen(
    doQuerySafe<LabAutomationAllSchemasQuery>({query: LAB_AUTOMATION_ALL_SCHEMAS_QUERY})
  );
  if (isLookupConfigValidForModal(modalPropsWithEnvironment)) {
    runModal(LookupConfigModal, modalPropsWithEnvironment);
  } else {
    notifications.error('This lookup is not supported in the UI. You can still edit it in the JSON editor.');
  }
}
